import { render, staticRenderFns } from "./stuTask.vue?vue&type=template&id=46a09c18&scoped=true&"
import script from "./stuTask.vue?vue&type=script&lang=js&"
export * from "./stuTask.vue?vue&type=script&lang=js&"
import style0 from "./stuTask.vue?vue&type=style&index=0&id=46a09c18&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a09c18",
  null
  
)

export default component.exports